// removed by extract-text-webpack-plugin
module.exports = {"nffs-icon-footer":"nffs-icon-footer","nffs-icon-footer-links-container":"nffs-icon-footer-links-container","nffs-icon-footer-powered":"nffs-icon-footer-powered","logo-wrapper":"logo-wrapper","nffs-icon-footer-links":"nffs-icon-footer-links"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconFooter/IconFooter.scss
// module id = 5566
// module chunks = 1